module.exports = __webpack_public_path__ + "static/media/YF43_2.9130cb93.jpg";